export const environment = {
  production: true,
  api: "https://apidulceriadecaroya.somee.com/api/",
  clientId:
    "546131860750-68lv1u8arrrq7lr7bi3073b3shut438j.apps.googleusercontent.com",
};
